import { FC } from 'react';
import { BodyText, Card, CircleButton, withStyles } from 'vopay';

import Dialog from '#shared/components/Dialog/Dialog';
import styles from './UpgradePlanBankDialog.module.scss';
import { useTranslation } from 'react-i18next';

import { Button } from '#shared/components/UI';

type UpgradePlanBankDialogProps = {
  onCancel: () => void;
  // Captured from useHostNavigate() by the opener — the dialog renders under
  // the DialogProvider, above the HostNavigationProvider, so the context
  // can't be read here directly.
  hostNavigate?: (path: string, state?: unknown) => void;
};

const cn = withStyles(styles);

const UpgradePlanBankDialog: FC<UpgradePlanBankDialogProps> = ({ onCancel, hostNavigate }) => {
  const { t } = useTranslation('translations', {
    keyPrefix: 'Shared.Customers.PaymentMethodsTab.Details.Verification.UpgradePlanBankDialog',
  });

  return (
    <Card className={cn('modalContainer')}>
      <Dialog.Title level="3" className={cn('title')}>
        {t('title', { defaultValue: 'Upgrade Your Plan!' })}
      </Dialog.Title>

      <div className={cn('closeButton')}>
        <CircleButton icon="close" size="large" circleFill onClick={onCancel} />
      </div>

      <BodyText className={cn('description')}>
        {t('description', {
          defaultValue: 'Verify the ownership of the Bank Account.',
        })}
      </BodyText>

      <Button
        className={cn('button')}
        colorScheme="primary"
        onClick={() => {
          onCancel();

          // Link-out via the host's onNavigate; the dialog just closes when the
          // host can't navigate. (dropped router state: ticketSubject)
          hostNavigate?.('/create-tickets', {
            ticketSubject: t('ticketSubject', { defaultValue: 'Enquiry about Microdeposit Bank Verification.' }),
          });
        }}
      >
        {t('contactSupportButton', { defaultValue: 'Contact Support' })}
      </Button>
    </Card>
  );
};

export default UpgradePlanBankDialog;
